import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import BuildingDetail from '../../components/building_detail/BuildingDetail';
import { createBuilding } from '../../redux/projects/projects_actions';

class BuildingCreateModal extends React.Component {
  constructor(props) {
    super(props);
    this.buildingDetail = null;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isCreatingBuilding !== this.props.isCreatingBuilding && !nextProps.isCreatingBuilding) {
      if (nextProps.errorMessage) {

      } else {
        this.props.onHide();
      }
    }
  }

  onSaveHandler() {
    const newBuilding = this.buildingDetail.getWrappedInstance().getWrappedInstance().getBuildingData();

    this.props.createBuilding({
      ...newBuilding,
      project_id: this.props.project.id
    });
  }

  render() {
    const { isCreatingBuilding, errorMessage, createBuilding, t, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {t('create building')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BuildingDetail
            fieldErrors={errorMessage}
            ref={ref => (this.buildingDetail = ref)}
            disabled={this.props.isCreatingBuilding}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            onSubmit={() => !this.props.isCreatingBuilding && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="building-submit-create"
            disabled={!isSubmittable || isCreatingBuilding}
            onClick={() => this.onSaveHandler()}
          >
            {this.props.isCreatingBuilding ? `${t('creating')}...` : t('create')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isCreatingBuilding: state.project.creating_building,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  createBuilding: building => dispatch(createBuilding(building)),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BuildingCreateModal)
);



// WEBPACK FOOTER //
// ./src/modal/buildings/BuildingCreateModal.js